import {Grid, Typography} from "@material-ui/core";
import ServiziTable from "./servizi-table/ServiziTable";
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import * as actions from '../../../../../../../store/contratto-digitale/actions'
import ApnDialog from "./servizi-details-dialog/ApnDialog";
import {Skeleton} from "@material-ui/lab";

const Servizi = () => {
    const {digitalContractId} = useParams()
    const dispatch = useDispatch()
    const serviziTables = useSelector((state) => state.contrattoDigitaleReducer.serviceLists)
    const loading = useSelector((state) => state.contrattoDigitaleReducer.serviceLists.loading)
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
    const cacheLoading = useSelector((state) => state.authReducer.cacheDigitalContractLoading)


    useEffect(() => {
        if (!cacheLoading) {
            dispatch(actions.getServiceTablesData(digitalContractId))
        }
    }, [dispatch, digitalContractId, cacheLoading])

    const mapTableData = (type) => {
        if (type === "apn") {
            return {
                descrizioneServizio: serviziTables.data.descrizioneServizioApn,
                canoneUnitario: serviziTables.data.canoneUnitarioApn
            }
        }
        return {
            descrizioneServizio: serviziTables.data.descrizioneServizioAssistenzaPremium,
            canoneUnitario: serviziTables.data.canoneUnitarioAssistenzaPremium
        }
    }

    return (
        <Grid container spacing={3}>
            <Grid item
                  xs={12}>
                <Typography variant="h6" className='ml-12'>Servizi inclusi nel contratto</Typography>
            </Grid>
            {loading || cacheLoading ?
                <Grid item xs={12}>
                    <Skeleton variant="rect" width="100%" height={200}/>
                </Grid> :
                <>
                    <Grid item
                          xs={12}>
                        {serviziTables.data.showApnPrivato ?
                            <ServiziTable title="APN Privato"
                                          setOpenDetailsDialog={setOpenDetailsDialog}
                                          tableData={mapTableData("apn")}
                                          loading={serviziTables.loading || cacheLoading}/>
                            : null}
                    </Grid>

                    <Grid item
                          xs={12}>
                        {serviziTables.data.showAssistenzaPremium ?
                            <ServiziTable title="Assistenza Premium"
                                          tableData={mapTableData("assistenzaPremium")}
                                          loading={serviziTables.loading || cacheLoading}/>
                            : null}
                    </Grid>
                </>
            }
            {openDetailsDialog ?
                <ApnDialog open={openDetailsDialog}
                           handleDialogClose={() => setOpenDetailsDialog(false)}/>
                : null}
        </Grid>
    )
};

export default Servizi;
